module.exports = __webpack_public_path__ + "assets/img/Balance.1edfeade.png";